module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.$t('nav.termsAndEnquiries')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group panel-select-group__justify"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v(_vm._s(_vm.$t('nav.contact')))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-body-contact"
  }, [(_vm.isTel) ? _c('div', {
    staticClass: "panel-body-phone panel-body-con-box"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('contact.phone')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body-con"
  }, _vm._l((_vm.tels), function(tel) {
    return _c('p', [_vm._v(_vm._s(tel))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isEmail) ? _c('div', {
    staticClass: "panel-body-email panel-body-con-box"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('contact.email')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body-con"
  }, _vm._l((_vm.emails), function(email) {
    return _c('p', [_vm._v(_vm._s(email))])
  }), 0)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group panel-select-group__justify"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v(_vm._s(_vm.$t('nav.terms')))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-body-contact"
  }, [_c('div', {
    staticClass: "panel-body-phone panel-body-con-box"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('nav.termsContent')))])]), _vm._v(" "), _c('div', {
    staticClass: "term_link"
  }, [_c('a', {
    attrs: {
      "href": "http://merchanttnc.s3-website-ap-southeast-1.amazonaws.com/",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('nav.termsLink')))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-c5bbdd2c"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/contact/contact.vue
// module id = 932
// module chunks = 0